// Utilidad para mostrar/ocultar y parpadear el botón Refresh desde otros componentes
export function showRefreshButton(blink = false) {
  const btn = document.getElementById('refresh-btn');
  if (btn) {
    btn.style.display = '';
    if (blink) {
      btn.classList.add('blink-refresh');
    } else {
      btn.classList.remove('blink-refresh');
    }
  }
}

export function hideRefreshButton() {
  const btn = document.getElementById('refresh-btn');
  if (btn) {
    btn.style.display = 'none';
    btn.classList.remove('blink-refresh');
  }
}
